<template>
  <div class="product-page">
    <!-- 顶部Banner图 -->
    <div class="top-banner">
      <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/banner2.png" alt="Banner" class="banner-image" />

      <div class="banner-info">
        <div class="label">智守合规</div>
        <div class="label em">械准无忧</div>
      </div>
    </div>

    <div class="product-item" :class="`type${i + 1}`" v-for="(item, i) in productList" :key="i">
      <div class="info">
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.description }}</div>
        <div class="btn" @click="toPath(item.path)">了解更多</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router' 
const router = useRouter()

const productList = [
  {
    title: "智慧法规库",
    description: "覆盖全球100+国家医疗器械法规，收录超50万条实时更新数据，助力企业高效合规，缩短产品上市周期30%以上。",
    path: 'law'
  },
  {
    title: "医疗器械行业数据",
    description: "涵盖超20万家企业和10万种产品，年更新数据超100万条，助力精准市场分析和决策支持。",
    path: 'medicalData'
  },
  {
    title: "行业资讯跟踪",
    description: "覆盖超500家权威媒体，年发布资讯逾10万条，助您实时掌握行业动态与市场趋势。",
    path: 'industryNews'
  },
  {
    title: "多语言文件转换",
    description: "准确度高达85%，支持50+语种，日均处理超10万字，轻松跨越语言障碍，沟通无国界。",
    path: 'language'
  },
  {
    title: "医疗器械注册服务",
    description: "服务近20家械企，提供从研发立项、注册申报到上市后变更的全生命周期法规管理。更结合自研AI工具，智能预警法规变化、优化申报策略，显著提升合规效率与成功率。",
    path: 'medicalRegister'
  },
]

const toPath = (path: any) => {
  if (path) {
    router.push({
      name: path 
    })
  }
}


</script>

<style lang="less" scoped>
.product-page {
  position: relative;
  min-height: 100vh;
  min-width: 1400px;
  background: #fff;
  padding-bottom: 30px;
  .banner-info {
    position: absolute;
    left: 100px;
    top: 0;
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .label {
      font-family: YouSheBiaoTiHei;
      font-size: 72px;
      line-height: 100px;
      color: #101010;
      &.em {
        text-indent: 2em;
        // padding-left: 160px;
      }
    }
  }
}

.top-banner {
  width: 100%;
  height: 600px;
  overflow: hidden;

  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}
.product-item {
  width: 100%;
  height: 400px;
  margin-top: 100px;
  &:nth-child(even) {
    position: relative;
    background: #f5f5f5;
    &:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: 740px;
      height: 300px;
      background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/product-bg1.png) right bottom / 100% 100% no-repeat;
      opacity: .4;
    }
  }
  &.type2 {
    position: relative;
    width: 80%;
    min-width: 1400px;
    border-radius: 0 100px 100px 0;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    border: 1px solid #ddd;
    border-left: none;
    overflow: hidden;
    .info {
      left: initial;
      right: 240px;
    }
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/product-bg2.png) center center / cover no-repeat;
      opacity: .3;
    }
  }
  &.type4 {
    position: relative;
    width: 80%;
    margin: 100px 0 0 auto;
    min-width: 1400px;
    border-radius:  100px 0 0 0;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    border: 1px solid #ddd;
    border-left: none;
    overflow: hidden;
    .info {
      left: 500px;
    }
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/product-bg2.png) center center / cover no-repeat;
      opacity: .3;
    }
  }
  .info {
    position: relative;
    z-index: 10;
    position: absolute;
    left: 200px;
    top: 50px;
    width: 400px;
    height: 400px;
    text-align: left;
    .title {
      
      font-size: 40px;
      font-weight: bold;
      color: #101010;
      line-height: 96px;
    }
    .desc {
      
      font-size: 18px;
      color: #101010;
      line-height: 30px;
    }
    .btn {
      margin: 30px 0 0 auto;
      background: #3019FF;
      width: 160px;
      height: 40px;
      color: #fff;
      border-radius: 20px;
      
      font-size: 16px;
      cursor: pointer;
      transition: all .3s;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        font-size: 16px;
        transform: scale(1.025);
        background: #1007dd;
      }
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1560px) {
  .product-page {
    min-width: 1200px;
    .top-banner {
      height: 540px;
      .banner-info {
        height: 540px;
        .label {
          font-size: 66px;
        }
      }
    }
    .product-item {
      &.type2, &.type4 {
        min-width: 1200px;
      }
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1400px) {
  .product-page {
    min-width: 1080px;
    .top-banner {
      height: 500px;
      .banner-info {
        height: 500px;
        .label {
          font-size: 60px;
        }
      }
    }
    .product-item {
      &.type2, &.type4 {
        min-width: 1080px;
      }
    }
  }
}
</style>